/**
 * True, wenn die URL auf das Protokoll eines einzelnen Punktes zeigt
 * (`/bohrpunkte/:id` inkl. Unter-Tabs wie `/bohrpunkte/:id/Boden`).
 *
 * Hintergrund: Der „Punkt Speichern"-Knopf in der Navbar wird über ein
 * globales Navbar-Kommando (`savePoint`) ein-/ausgeblendet, das die
 * Editor-Komponenten beim Verlassen aufräumen müssen. Bleibt dieser Zustand
 * in einem ungünstigen Verlassen-Pfad hängen (Route-Caching der Karte,
 * geteilter dirty-Schalter), erscheint der Knopf auf der Karte. Diese
 * Prüfung bindet den Knopf zusätzlich an die Route, sodass er außerhalb
 * eines Protokolls nie sichtbar sein kann.
 *
 * Bewusst ausgeschlossen: die Druck-Ansichten (`/bohrpunkte/Drucken/...`)
 * und die Sandbox (`/bohrpunkte/sandbox`) — das sind keine Protokolle.
 */
export function isPointDetailUrl(url: string | null | undefined): boolean {
	if (!url) return false;
	// Query-String und Fragment abschneiden.
	const path = url.split('?')[0].split('#')[0];
	const parts = path.split('/').filter(Boolean);
	if (parts[0] !== 'bohrpunkte') return false;
	// `/bohrpunkte` (Fehler-Route) hat keine Id.
	if (parts.length < 2) return false;
	const id = parts[1];
	return id !== 'Drucken' && id !== 'sandbox';
}
